import { ChangeDetectionStrategy, Component, Input, Optional } from '@angular/core';

@Component({
  selector: 'ui-platform-progress-indicator-line',
  templateUrl: './progress-indicator-line.component.html',
  styleUrl: './progress-indicator-line.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UiPlatformProgressIndicatorLineComponent {
  @Input() progress = 0;
  @Optional() @Input() color: 'primary' | 'grey' = 'primary';

  get leadWidth() {
    return {
      'min-width': this.progress ? '0.5rem' : undefined,
      'width': this.progress === 100 ? '100%' : `calc(${this.progress}% - 0.4rem)` // TODO do not hard-code right gap
    };
  }

  get leadDynamicClass() {
    return [`color-${this.color}`];
  }
}
